@if (dataLoaded()) {
  <div class="stu-work-detail-issue">
    <div class="pre-page spen-mod-heading lv-1">
      <h1 class="heading-text">
        <a (click)="onBack()"><i class="fa fa-chevron-left"></i></a>課題回答
      </h1>
    </div>
    <div class="block-standard">
      <div class="spen-mod-heading lv-2 header-title">
        <p class="descr-heading">課題に合わせて、活動記録を作成してください。</p>
        <h2 class="heading-text">{{ work.title }}</h2>
      </div>
      <div class="user-info">
        <img [src]="work.create_user.avatar" />
        <div class="text-info">
          <p>{{ work.delivered_at }}</p>
          <p>{{ work.create_user.name }}</p>
        </div>
      </div>
      @if (work.comment) {
        <div class="box-comment">
          <span class="tip-up"></span>
          <span class="tip-up-large"></span>
          <p appConvertLink>{{ work.comment }}</p>
        </div>
      }
      @if (work.upload_files) {
        <div class="thumb">
          <app-files-view-student [files]="work.upload_files"></app-files-view-student>
        </div>
      }
    </div>
    <div class="template">
      <p class="tem-heading">活動記録作成</p>
      <div class="btn-show-history">
        <a class="spen-util-link" (click)="showModalActivities()">
          <span>過去の活動記録を見る</span>
        </a>
      </div>
      @if (form) {
        <form [formGroup]="form" appScrollToFirstInvalid>
          <div class="form-horizontal">
            <div class="form-group">
              <div class="row">
                <div class="col-md-3 col-xs-12">
                  <p class="label-input">タイトル</p>
                </div>
                <div class="col-md-9 col-xs-12">
                  @if (work.answer_title) {
                    <p class="title">{{ work.answer_title }}</p>
                  } @else {
                    <input
                      class="spen-mod-input-text"
                      type="text"
                      [appPlaceholder]="'入力してください'"
                      formControlName="title"
                      name="title"
                      [appFocus]="focusEvent"
                    />
                    @if (formErrors['title']) {
                      <div class="spen-mod-error-content">
                        {{ formErrors['title'].join(' ') }}
                      </div>
                    }
                  }
                </div>
              </div>
            </div>
            <div>
              @switch (work.work_type) {
                @case ('single') {
                  <div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-3 col-xs-12">
                          <p class="label-input">本文</p>
                        </div>
                        <div class="col-md-9 col-xs-12">
                          <label class="spen-mod-select">
                            <select class="select" name="template_id" (change)="onChangeTemplate($event)">
                              <option class="is-all-point select-option" [value]="null">テンプレートを選択</option>
                              @for (template of templates; track template.id) {
                                <option class="is-part-point select-option" [value]="template.id">
                                  {{ template.title }}
                                </option>
                              }
                            </select>
                            <i class="fa fa-caret-down"></i>
                          </label>
                        </div>
                        <div class="col-md-3 col-xs-12"></div>
                        <div class="col-md-9 col-xs-12">
                          <textarea rows="4" cols="50" class="" [appPlaceholder]="'入力してください'" formControlName="content"> </textarea>
                          @if (formErrors['content']) {
                            <div class="spen-mod-error-content">
                              {{ formErrors['content'].join(' ') }}
                            </div>
                          }
                          <p class="text-num pull-right">
                            文字数 <span class="num-character">{{ lengthOfContent }}</span>
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="row">
                        <div class="col-md-3 col-xs-12">
                          <p class="label-input">添付ファイル</p>
                        </div>
                        <app-file-uploader
                          class="col-sm-12 col-xs-12"
                          [attachedFiles]="document.upload_files"
                          (eventSelectFile)="onSelectFile($event)"
                          (uploadFilesStatus)="onUploadFilesStatus($event)"
                        >
                        </app-file-uploader>
                      </div>
                    </div>
                  </div>
                }
                @case ('multiple') {
                  <div>
                    <div formArrayName="document_answers_attributes">
                      @for (answer of formDocumentAnswers; track answer; let i = $index) {
                        <div class="form-group">
                          <div class="row">
                            <div class="col-md-3 col-xs-12">
                              <div class="label-input">
                                項目{{ i + 1 }}
                                @if (work.is_compass_template) {
                                  <span class="required">必須</span>
                                }
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-9 col-xs-12">
                              <p
                                class="work-question-content"
                                [ngClass]="{ 'single-choice-question-content': work.work_questions[i].is_single_choice }"
                                appConvertLink
                              >
                                {{ work.work_questions[i].content.description || work.work_questions[i].content }}
                              </p>
                            </div>
                            @if (work.work_questions[i]['image']) {
                              <div class="col-md-9 col-xs-12 question-image">
                                <img src="{{ work.work_questions[i]['image']['thumbnail'] }}" />
                              </div>
                            }
                          </div>
                          <div class="row">
                            <div class="col-md-9 col-xs-12" [formGroupName]="i">
                              @if (!work.work_questions[i].is_single_choice) {
                                <textarea rows="4" cols="50" class="" [appPlaceholder]="'入力してください'" formControlName="text_content">
                                </textarea>
                                @if (getFormErrorsAnswerIndex(i)['text_content']) {
                                  <div class="spen-mod-error-content">
                                    {{ getFormErrorsAnswerIndex(i)['text_content'].join(' ') }}
                                  </div>
                                }
                                <p class="text-num pull-right">
                                  文字数
                                  <span class="num-character">{{ answer.get('text_content').value.length }}</span>
                                </p>
                              } @else {
                                <div class="answer-options">
                                  @for (option of work.work_questions[i].content.options; track option) {
                                    <div class="answer-option">
                                      <label class="spen-mod-radio">
                                        <input class="radio" formControlName="single_choice_content" type="radio" [value]="option" /><i
                                          class="fa"
                                        ></i>
                                        <div class="option-text">{{ option }}</div>
                                      </label>
                                    </div>
                                  }
                                </div>
                                @if (getFormErrorsAnswerIndex(i)['single_choice_content']) {
                                  <div class="spen-mod-error-content">
                                    {{ getFormErrorsAnswerIndex(i)['single_choice_content'].join(' ') }}
                                  </div>
                                }
                              }
                              <div
                                class="select-images-multiple-work"
                                [ngClass]="{ 'single-choice-images': work.work_questions[i].is_single_choice }"
                              >
                                <app-file-uploader
                                  [index]="i"
                                  [attachedFiles]="answer.upload_files"
                                  (eventSelectFile)="onSelectFile($event)"
                                >
                                </app-file-uploader>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
              }
            </div>
            @if (work.category_id) {
              <div class="form-group category-block">
                <div class="row">
                  <div class="col-md-4 col-sm-4 col-xs-6">
                    <div class="category-text">
                      {{ categoryName }}
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="form-group">
                <div class="row">
                  <div class="col-md-3 col-xs-12">
                    <p class="label-input">カテゴリー</p>
                  </div>
                  <div class="col-md-9 col-xs-12">
                    <app-categories-selection formControlName="category_id" [categories]="categories"> </app-categories-selection>
                  </div>
                </div>
              </div>
            }
          </div>
          <div class="block-marks">
            <app-marks-selector [marks]="marks" (eventChangeMark)="onChangeMark()"></app-marks-selector>
          </div>
          <div class="block-last">
            <button
              type="submit"
              class="spen-mod-btn is-primary"
              (click)="onSubmit(true)"
              [disabled]="isSubmitting || uploadFilesStatus === 'uploading'"
            >
              回答を完了する
            </button>
            <button
              type="submit"
              class="spen-mod-btn"
              (click)="onSubmit(false)"
              [disabled]="isSubmitting || uploadFilesStatus === 'uploading'"
            >
              一時保存する
            </button>
            <button type="button" class="spen-mod-btn" (click)="onBack()">戻る</button>
          </div>
        </form>
      }
    </div>
  </div>
} @else {
  <div class="spen-mod-flex-loading"><div class="loading-icon"></div></div>
}

@if (uploaderAll.isUploading) {
  <app-upload-files-progress [progress]="uploaderAll.progress" (cancelFilesEvent)="cancelUploadingFiles()"> </app-upload-files-progress>
}

@if (showListActivityModal) {
  <app-list-activity-modal (eventShowActivity)="eventShowActivity($event)" (eventSelectActivityModal)="eventSelectActivityModal($event)">
  </app-list-activity-modal>
}

@if (showActivityDetailModal) {
  <app-activity-detail-modal [activityId]="activityId" (eventForBackAction)="eventForBackAction($event)" />
}
